module.exports = __webpack_public_path__ + "static/elastic-256f49281260b95e36a66f31ba55529d.png";